module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/map-th-7c851388d0dc91cf8c5409b5410395fb.png";